export enum VinLoadOption {
  FSS = 'fss',
  VINS_LIST = 'vinsList',
  VINS_FILE = 'vinsFile',
}
